import RouteNotFound from 'routes/RouteNotFound';

import VaultDocument from './Document';

const routes = [
  {
    path: '/vault',
    children: [
      {
        index: true,
        element: <RouteNotFound />,
      },
      {
        path: 'document/:documentId',
        element: <VaultDocument />,
      },
    ],
  },
];

export default routes;
